import React, { useEffect } from 'react';
import usePlayer from './usePlayer';
const VideoPlayer = (props) => {
    const { videoSrc, setVideoErrored, muxDataKey, setPlaybackRate, playbackRate, posterSrc, videoRef, preload, pausePlayer, onPlay } = props;
    const { player, error } = usePlayer({
        videoSrc,
        videoRef,
        muxDataKey,
        playbackRate,
        setPlaybackRate,
        posterSrc,
        preload,
        pausePlayer,
        onPlay
    });
    useEffect(() => {
        if (!videoSrc || !player || player.src() === videoSrc)
            return;
        player.src(videoSrc);
    }, [videoSrc, player]);
    useEffect(() => {
        if (!player || player.poster() === posterSrc || !posterSrc)
            return;
        player.poster(posterSrc);
    }, [posterSrc, player]);
    useEffect(() => {
        if (error) {
            if (setVideoErrored)
                setVideoErrored(true);
        }
    }, [error, setVideoErrored]);
    return (React.createElement("div", { "data-vjs-player": true },
        React.createElement("video", { ref: videoRef, className: "video-js vjs-user-inactive vjs-custom-skin vjs-inline", playsInline: true })));
};
export default VideoPlayer;
//# sourceMappingURL=index.js.map